import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';

@Component
export default class EpicBottomProfile extends Vue {
    @Prop({ default: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/leader-profile.png' })
    public profileImg!: string;

    @Prop({ default: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/bg.png' })
    public bgImg!: string;

    @Prop({ default: 'Johnson JI' })
    public name!: string;

    @Prop({ default: 'FOUNDER CEO' })
    public title!: string;

    @Prop({ default: `RIFO Holding Group Founder，Standing director of Canada-China Realty Professional Association.
    President of Eastside Realty and RealJaJa Group. Over 23 years experience in business management and real estate industry.
    Won the 9th Canadian Outstanding Chinese Business Awards.` })
    public des!: string;

    @Prop({ default: function() {
        return [{
            img: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/profile-image-1.png',
            imgTitle: 'Mr. Johnson & Prime Minister Justin Trudeau'
        }, {
            img: 'https://files.realjaja.com/rifo-web/epic/imgs/rifo-design/epic-about-us/profile-image-2.png',
            imgTitle: 'Mr. Johnson & Premier of Ontario Doug Ford'
        }];
        }
    })
    public imgList!: {img: string, imgTitle: string}[];

    @Prop({ default: function() {
        const configs = new CommonConfig();
        return [
            `${configs.rifoDesignAssetsUrl}/epic-about-us/profile-logo-1.png`,
            `${configs.rifoDesignAssetsUrl}/epic-about-us/profile-logo-2.png`,
            `${configs.rifoDesignAssetsUrl}/epic-about-us/profile-logo-3.png`,
            `${configs.rifoDesignAssetsUrl}/epic-about-us/profile-logo-4.png`];
        }
    })
    public partners!: string[];
}

